import { VacancyAlarmMain } from "../../components/templates";

export const VacancyAlarmPage = () => <VacancyAlarmMain />;
